import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {VcrEntity} from '@app/models/vcr-entity/entity';
import {concatMap} from 'rxjs/operators';
import {Group} from '@app/models/vcr-entity/group';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';

@Injectable({
  providedIn: 'root'
})
export class GroupService {
  public room: ClassroomStateModel;
  constructor(private http: HttpClient, private store: Store) {
    this.listenStoreChanges();
  }

  public getGroupInfoById(groupPortalId): Observable<Group> {
    return this.http.get( `${this.room.vcrURL}/curriculum/group-by-portal-id/${groupPortalId}`).pipe(concatMap(result => {
      if (result) {
        return of(VcrEntity.createEntity(Group, result));
      } else {
        throwError('Class not found, can not be selected. groupId: ' + groupPortalId);
      }
    }));
  }

  public extractFromGroupNameYearAndBranch(groupName) {
    const groupNameSplit = groupName.split('.');

    if (groupNameSplit.length !== 3) {
      return groupName;
    }

    if (isNaN(parseInt(groupNameSplit[0]))) {
      console.log('can`t parse year.');
      return groupName;
    }

    return groupNameSplit[2];
  }

  private listenStoreChanges() {
    this.store.select(ClassroomState).subscribe((room: ClassroomStateModel) => {
      this.room = room;
    });
  }
}
